module.exports = __webpack_public_path__ + "img/TEQCUERVO1800ANEJO.cb873ddf.jpg";